const getFileIcon = (filename) => {
    let isLink = filename.includes("://");
    if (isLink) {
        return require('@/assets/file-icons/file-ftp.svg')
    } else {
        let re = /(?:\.([^.]+))?$/;
        let suffix = re.exec(filename)[1]

        switch(suffix) {
            case 'ai' :
                return require('@/assets/file-icons/file-ai.svg')
            case 'doc' :
            case 'docx':
            case 'pages':
            case 'txt':
                return require('@/assets/file-icons/file-doc.svg')
            case 'jpg' :
            case 'gif' :
            case 'jpeg' :
            case 'png' :
            case 'bmp' :
                return require('@/assets/file-icons/file-image.svg')
            case 'indd' :
                return require('@/assets/file-icons/file-indd.svg')
            case 'pdf' :
                return require('@/assets/file-icons/file-pdf.svg')
            case 'key' :
            case 'keynote' :
            case 'ppt' :
            case 'pptx' :
                return require('@/assets/file-icons/file-presentation.svg')
            case 'psd' :
            case 'psb' :
                return require('@/assets/file-icons/file-psd.svg')
            case 'csv' :
            case 'xlsx' :
            case 'xls' :
            case 'numbers' :
                return require('@/assets/file-icons/file-spreadsheet.svg')
            case 'svg' :
            case 'eps' :
                return require('@/assets/file-icons/file-vector.svg')
            case 'zip' :
            case 'rar' :
            case 'xar' :
            case '7z' :
            case 'iso' :
                return require('@/assets/file-icons/file-zip.svg')
            default :
                return require('@/assets/file-icons/file-generic.svg')
        }
    }
}
export default getFileIcon